export default __webpack_public_path__ + "static/media/empty-state-folder.2a41ec7f.png";